export default __webpack_public_path__ + "static/media/logo.b5cf08c0.webp";